import { call, put, takeLatest, all, takeEvery } from 'redux-saga/effects';

import { hasC7Innovate2026 } from 'common/helpers/featureFlags';
import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { listCustomerProductRatings } from 'redux/customerProductRating/actions';

import { listOrders, getOrder, getCustomerOrder } from './api';
import {
  LIST_ORDERS_REQUEST,
  GET_ORDER_REQUEST,
  GET_ORDER_SUCCESS,
  ORDER_OBJECT_REQUESTING,
  ORDER_LIST_REQUESTING,
  LIST_ORDERS_SUCCESS,
  RESET_ORDER_ISFETCHING,
  GET_CUSTOMER_ORDER_REQUEST
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: ORDER_LIST_REQUESTING });
    const response = yield call(listOrders, customerId(), action.queryString);
    yield put({ type: LIST_ORDERS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_ORDER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* get(action) {
  // Function is used in cart area so nexts an export
  try {
    yield call(removeAPIError);
    yield put({ type: ORDER_OBJECT_REQUESTING });
    const response = yield call(getOrder, action.orderId);
    yield put({ type: GET_ORDER_SUCCESS, payload: response.data });
    if (hasC7Innovate2026()) {
      // Chain: fetch all product ratings after order fetch
      yield put(listCustomerProductRatings());
    }
  } catch (error) {
    yield put({ type: RESET_ORDER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* getOrderForCustomer(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: ORDER_OBJECT_REQUESTING });
    const response = yield call(getCustomerOrder, customerId(), action.orderId);
    yield put({ type: GET_ORDER_SUCCESS, payload: response.data });
    if (hasC7Innovate2026()) {
      // Chain: fetch all product ratings after order fetch
      yield put(listCustomerProductRatings());
    }
  } catch (error) {
    yield put({ type: RESET_ORDER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_ORDERS_REQUEST, list);
  yield takeLatest(GET_ORDER_REQUEST, get);
  yield takeEvery(GET_CUSTOMER_ORDER_REQUEST, getOrderForCustomer);
}

export default function* orderSagas() {
  yield all([watchList()]);
}
